import { isNumber } from '@/helpers/is';

/**
 * transform number to natural number
 * @param {number} d
 * @returns {string}
 */
const natural = (d) => {
  if (isNumber(d)) {
    return Math.abs(d);
  } if (typeof d === 'string' && !Number.isNaN(Number(d))) {
    return Math.abs(Number(d));
  }
  return d;
};

export default natural;
